import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BlFrontendButtonComponent } from '@core/wrappers/bl-frontend-button.component';
import { TranslocoModule } from '@jsverse/transloco';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { BlFrontendIconComponent } from 'src/app/core/wrappers/bl-frontend-icon.component';
import { BlFrontendTooltipComponent } from 'src/app/core/wrappers/bl-frontend-tooltip.component';
import { TableFilterItemComponent } from './components/table-filter-item.component';
import { TableFilterComponent } from './components/table-filter.component';
import { TableRefreshButtonComponent } from './components/table-refresh-button.component';
import { TableTemplateDirective } from './directives/table-template.directive';
import { TransformParamPipe } from './pipe/transform-param.pipe';
import { TableComponent } from './table.component';
import { BlFrontendTextInputComponent } from 'src/app/core/wrappers/bl-frontend-text-input.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    MultiSelectModule,
    InputTextModule,
    CheckboxModule,
    TableFilterItemComponent,
    CheckboxModule,
    TranslocoModule,
    BlFrontendButtonComponent,
    BlFrontendTooltipComponent,
    BlFrontendIconComponent,
    BlFrontendTextInputComponent,
  ],
  declarations: [
    TableComponent,
    TableFilterComponent,
    TableTemplateDirective,
    TableRefreshButtonComponent,
    TransformParamPipe,
  ],
  exports: [
    TableComponent,
    TableFilterComponent,
    TableFilterItemComponent,
    TableTemplateDirective,
    TableRefreshButtonComponent,
  ],
})
export class BystTableModule {}
